import { queryOptions } from "@tanstack/react-query";

import { withViewerScope } from "@/lib/viewer-scoped-query";
import { client, orpc } from "@/utils/orpc.client";

/** Keeps one distribution snapshot per viewer for the lifetime of the document. */
export function distributionAvailabilityQueryOptions(viewerId: string | null, identity: string) {
  const scoped = withViewerScope(
    orpc.notifications.getDistributionAvailability.queryOptions({}),
    viewerId,
  );
  return queryOptions({
    queryKey: [...scoped.queryKey, identity],
    queryFn: async () => {
      try {
        return await client.notifications.getDistributionAvailability();
      } catch (error) {
        console.error("Failed to load distribution availability", error);
        return null;
      }
    },
    staleTime: Infinity,
    gcTime: Infinity,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchInterval: false,
    retry: false,
  });
}
